/**
 * Updates the recently viewed products in localStorage so they persist across visits.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in local storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    if (!productId) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch {
      // Private browsing or storage restrictions should not break product pages.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {
      // Ignore storage restrictions; the UI can still continue without the list.
    }
  }

  /**
   * Retrieves the list of recently viewed products from local storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const storedProducts = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(storedProducts) ? storedProducts.filter(Boolean).map(String) : [];
    } catch {
      return [];
    }
  }
}
